import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import TopNav from './components/TopNav';
import BottomBar from './components/BottomBar';
import ScrollToTop from './components/ScrollToTop';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CarSection from './pages/CarSection';
import HealthSection from './pages/HealthSection';
import Settings from './pages/Settings';
import GymSection from './pages/GymSection';
import JobSection from './pages/JobSection';
import TodoSection from './pages/TodoSection';
import { appRoutes } from './routes';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

// Main Layout Component
const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-theme-secondary">
      <TopNav />
      <main className="pt-16 pb-20">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          {appRoutes.map((route) => {
            if (route.path === '/car') {
              return <Route key={route.id} path="/car/*" element={<CarSection />} />;
            }
            if (route.path === '/health') {
              return <Route key={route.id} path="/health/*" element={<HealthSection />} />;
            }
            if (route.path === '/gym') {
              return <Route key={route.id} path="/gym/*" element={<GymSection />} />;
            }
            if (route.path === '/job') {
              return <Route key={route.id} path="/job/*" element={<JobSection />} />;
            }
            if (route.path === '/todo') {
              return <Route key={route.id} path="/todo" element={<TodoSection />} />;
            }
            if (route.path === '/settings') {
              return <Route key={route.id} path="/settings" element={<Settings />} />;
            }
            return null;
          })}
        </Routes>
      </main>
      <BottomBar />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App; 